import React from 'react';
import classes from '../../price-breaks-popup.scss';
export default function DescriptionPrice() {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.subtitle
  }, "Order big, save even bigger!"), /*#__PURE__*/React.createElement("div", {
    className: classes.description
  }, "As you increase the size of your order, the cost per item decreases. This is based on a 1 color print and does not include set up fees. The larger percentage savings occur at these quantities:"));
}